export const IMPERSONATE_USER = 'IMPERSONATE_USER';
export const IMPERSONATE_USER_SUCCESS = 'IMPERSONATE_USER_SUCCESS';
export const IMPERSONATE_USER_FAILURE = 'IMPERSONATE_USER_SUCCESS_FAILURE';
export const CLEAR_IMPERSONATION = 'CLEAR_IMPERSONATION';
